import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="cp-footer">
      <div className="cp-footer-inner">
        <div className="cp-footer-links">
          <Link to="/">Home</Link>
          <Link to="/subquery">SubQuery</Link>
          <Link to="/subspace">Subspace</Link>
          <Link to="/thegraph">The Graph</Link>
          <Link to="/celestia">Celestia</Link>
        </div>
        <div className="cp-footer-contact">
          <a href="mailto:info@counterpoint.software?subject=Website Contact">info@counterpoint.software</a>
        </div>
        <div className="cp-footer-copy">
          &copy; {new Date().getFullYear()} counterpoint software
        </div>
      </div>
    </footer>
  );
}

export default Footer;
